import { render, staticRenderFns } from "./PassengerImportList.vue?vue&type=template&id=dc153850"
import script from "./PassengerImportList.vue?vue&type=script&lang=js"
export * from "./PassengerImportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports